import { http } from '@/core/api/';
const schoolBaseURL = 'api/schools';

export default {
  getFiscalYears() {
    return http.get('api/code/fiscalyears');
  },
  getStatusList() {
    return http.get('api/code/materialsequipmentstatus');
  },
  getMunicipalities() {
    return http.get(`${schoolBaseURL}/municipalities`);
  },
  getRegions() {
    return http.get('api/location/activeregions');
  },
  getSchools() {
    return http.get(`${schoolBaseURL}/getLocationSchools`);
  },
  getSaloonTypes() {
    return http.get('api/code/me/saloon');
  },
  getLevelTypes() {
    return http.get('api/code/materialsequipmentleveltypes');
  },
  getCategories(parameter) {
    return http.get(`api/code/me/category/${parameter.saloonId}`);
  },
  getItemTypes(parameter) {
    return http.get(
      `api/code/me/${parameter.saloonId}/${parameter.categoryId}`
    );
  },
  getDocumentTypes() {
    return http.get('api/documents/documenttypes', {
      params: { codeType: 'PeiMaterialsEquipment' },
    });
  },
  hasNewRequestsByItemType(id) {
    return http.get(`api/me/request/itemtype/${id}/hasnewrequests`);
  },
  saveItemType(params) {
    return http.post('api/me/request/itemtype', params);
  },
  async deleteItemType(id) {
    try {
      await http.delete(`api/me/request/itemtype/${id}`);
      return true;
    } catch {
      return null;
    }
  },
};
